<template>
  <section class="pt-7 px-9 roboto mx-auto flex course-box homecontainer ">
    <div class="video-body w-9/12 video-box px-4 pt-2">
      <ContentVideo 
        :url="url_mix"
        :type="GET_LESSON_SELECTED.type"
        v-if="url_mix!='' && renderComponent"
        @timeVideo="setTimeVideo"
        @userResourse="userResourse"
      />
    </div>
    <div class="interaction-body w-3/12 px-2 info-box mt-2">
      <p class="text-center">
        <Button
          py="s"
          @click="bookMentory"
          :text="'Agendar mentoría'"
          text_color="white"
          v-if="hasMentory"
        />
      </p>
      <div class="flex flex-wrap items-center justify-around text-skin-secondary mb-3 border-b-2 border-gray-300 border-solid">
        
        <div
          class="itemx cursor-pointer py-2"
          :class="[
            tab_selected === 0 ? ['selected_tab', 'text-skin-primary'] : '',
          ]"
          @click="tab_selected = 0"
        >
          Módulos
        </div>
        <div
          class="itemx cursor-pointer py-2"
          :class="[
            tab_selected === 1 ? ['selected_tab', 'text-skin-primary'] : '',
          ]"
          @click="tab_selected = 1"
        >
          Apuntes
        </div>
        <div
          class="itemx cursor-pointer py-2"
          :class="[
            tab_selected === 2 ? ['selected_tab', 'text-skin-primary'] : '',
          ]"
          @click="tab_selected = 2"
        >
          Comentarios
        </div>
      </div>
      <div class="notes-body">
        <ModulesLayout v-if="tab_selected === 0"></ModulesLayout>
        <NotesLayout v-if="tab_selected === 1" :time="time"></NotesLayout>
        <CommentsLayout v-if="tab_selected === 2"></CommentsLayout>
      </div>
    </div>
  </section>
</template>

<script>
import ContentVideo from "../components/ContentVideo.vue";
import NotesLayout from "../components/NotesLayout.vue";
import CommentsLayout from "../components/CommentsLayout.vue";
import ModulesLayout from "../components/ModulesLayout.vue";
import Button from "../components/Button.vue";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      tab_selected: 0,
      vimeo_url: "https://player.vimeo.com/video/",
      url_mix: "",
      time:0,
      vimeo: '',
      iframeShow: true,
      renderComponent: true,
      userResourseCont: true,
      activeElem:0,
      hasMentory:false,
    };
  },
  components: {
    NotesLayout,
    CommentsLayout,
    ModulesLayout,
    ContentVideo,
    Button
  },
  computed: {
    ...mapGetters("detailCourse", ["GET_LESSON_SELECTED"]),
    userId() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  mounted() {
    this.$store.commit("footer", false);
    this.$store.commit("showSearchCart", false);
    this.getNotesCourse();
    this.getMountedCourse();
    this.getQuestionsCourse();
    this.hasMentories()
    
  },
  methods: {

    bookMentory() {

      this.$router.push({
        name: "v2-mentories",
        params: {
          slug: this.$route.params.id
        }
      });
      
    },

    getQuestionsCourse() {
      let body = {
        mounted_courses_id: this.$route.params.id,
      };
      this.$store.dispatch("questions/get_questions_course", {
        _body: body,
      });
    },

    getNotesCourse() {
      this.$store.dispatch("notes/get_notes_course", {
        _mounted_course_id: this.$route.params.id,
      });
    },

    getMountedCourse() {
      let body = {
        user_id: this.userId.id,
        mounted_course_id: this.$route.params.id,
      };
      this.$store.dispatch("detailCourse/get_mounted_course", { body });
    },

    setTimeVideo(val){
      this.time =  Math.round(val)
    },

    userResourse(){
      if(this.GET_LESSON_SELECTED.resource_person.length==0 && this.userResourseCont){
        this.userResourseCont= false
        let body = {
            resource_id: this.$route.params.resource,
            mounted_course_id: this.$route.params.id,
        };
        this.$store.dispatch("userCourses/post_user_resourse", {
          _body: body,
        }).then(() => {
          this.userResourseCont = true
          this.$store.commit("userCourses/SET_ADDCOURSEUSER", true)
          this.getProgress()
        });
      }
    },
     getProgress() {
              
      let body = {
        _mounted_course_id: this.$route.params.id,
      }
      this.$store.dispatch("progress/get_progress", {
        _body: body,
      });
    },

    async hasMentories(){

      var url = "/api/v2/mounted-course/has-mentory/"+this.$route.params.id;
      let response = await axios.get(url, (axios.defaults.headers.common["Authorization"] ="Bearer " + localStorage.getItem("a_t")))
      this.hasMentory = response.data
    
    }
    

  },
  watch: {
    GET_LESSON_SELECTED() {
      this.url_mix = this.vimeo_url + this.GET_LESSON_SELECTED.data.id_video;
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
  },
};
</script>

<style scoped>

.itemx {
  font: normal normal medium 15px Roboto;
  font-size: 15px !important;
  letter-spacing: 0px;
  opacity: 1;
}

.interaction-body {
  min-height: calc(100vh - 250px);
}

.selected_tab {
  font: normal normal 900 15px/22px Roboto;
  letter-spacing: 0px;
  opacity: 1;
}

.notes-body {
  overflow: auto;
  height: calc(100vh - 200px);
}

/* Hide scrollbar for Chrome, Safari and Opera */
.notes-body::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.notes-body {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

@media (max-width: 1024px) {
  .course-box {
    flex-direction: column !important;
    padding: 0;
  }

  .video-box {
    width: 100%;
  }

  .info-box {
    width: 100%;
  }
}

</style>
